import { render, staticRenderFns } from "./towerWarn.vue?vue&type=template&id=056ca890&scoped=true&"
import script from "./towerWarn.vue?vue&type=script&lang=js&"
export * from "./towerWarn.vue?vue&type=script&lang=js&"
import style0 from "./towerWarn.vue?vue&type=style&index=0&id=056ca890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ca890",
  null
  
)

export default component.exports